import { IObserver, IMapData, IGridCell, IGridCells, IDatastore, INode, INodesList } from "./interface";

const MAP_GRID_SELECTOR: string = ".atlas-map__grid";
const GRIDITEM_TEMPLATE = require('./view/grid-item.handlebars');

export class AtlasGridItem implements IObserver<IMapData> {
  private mapData: IMapData;
  private node;

  public constructor(private Datastore: IDatastore<IMapData, IGridCells>, private GridCellData: IGridCell, private id: number) {
    this.Render();
  }

  public ReceiveUpdate(Data: INodesList, Associations: IMapData) {
    if (Associations) {
      this.mapData = Associations;
      const node = this.getNode();
      if (node) {
        this.node = node;
      } else {
        this.node = false;
      }
      this.UpdateRender();
    }
  }

  public Bind() {
    $("#grid-item-" + this.id)
      .find(".atlas-map__grid__item__select-wrapper")
      .on("click", () => {
        this.Datastore.Popup.Show(this.node, this.GridCellData.gridX, this.GridCellData.gridY);
      });

    $("#grid-item-" + this.id)
      .find(".atlas-map__grid__item__nonode")
      .on("click", () => {
        this.Datastore.Popup.Show(this.node, this.GridCellData.gridX, this.GridCellData.gridY);
      });
  }

  private getNode() {
    return this.mapData.nodes.find(data => data.cell.gridX === this.GridCellData.gridX && data.cell.gridY === this.GridCellData.gridY && data.cell.gridX >= 0);
  }

  public UpdateData() {}

  public UpdateRender() {
    let hasSpawn = false;
    if (this.GridCellData.alias.spawnRegions && this.GridCellData.alias.spawnRegions.length > 0) {
      hasSpawn = true;
    }

    $("#grid-item-" + this.id).replaceWith(GRIDITEM_TEMPLATE({
        hasSpawn: hasSpawn,
        id: this.id,
        y: this.GridCellData.gridY,
        x: this.GridCellData.gridX,
        alias: this.GridCellData.alias.alias,
        node: this.node
      }));

    this.Bind();
  }

  public Render() {
    $(MAP_GRID_SELECTOR).append(GRIDITEM_TEMPLATE({
        hasSpawn: false,
        id: this.id,
        y: this.GridCellData.gridY,
        x: this.GridCellData.gridX,
        alias: this.GridCellData.alias.alias,
        node: this.node
      }));

    this.Bind();
  }
}
